export default __webpack_public_path__ + "static/assets/med_x_vial_mask.4a09e67e.png";